import React, {useState} from "react";
import ReactTable from "../../components/ReactTableWrapper";
import SweetAlert from "../../components/SweetAlertWrapper";

import connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import Add from "@material-ui/icons/Add";

import percursosStyle from "assets/jss/material-dashboard-pro-react/views/percursosStyle";
import UserSearch from "../../components/UserSearch";
//FontAwesome Icons
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

class Percursos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percursos: [],
      searchTable: ""
    };

    this.novoPercurso = this.novoPercurso.bind(this);
    this.apagarPercurso = this.apagarPercurso.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.reloadPercursos = () => {
      connection.get("percurso/listagem", null, (data) => {
        if (data.success) {
          let percursos = data.percursos;
          percursos.forEach((percurso) => {
            percurso.actions = (<React.Fragment>
              <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  window.App.hist.push("/percurso/" + percurso.id);
                }}
                color="info"
                className="edit"
              >
                <FontAwesomeIcon icon={faSearchPlus}/>
              </Button>
              {percurso.pode_apagar && <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  this.apagarPercurso(percurso)
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faTrashAlt}/>
              </Button>}
            </React.Fragment>);
          });
          this.setState({
            percursos: percursos,
            modal: null
          })
        }
      });
    }
  }

  componentDidMount() {
    this.reloadPercursos();
  }

  apagarPercurso(percurso) {
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Percurso"
          onConfirm={() => {
            connection.post("percurso/apagar", {id: percurso.id}, (data) => {
              if (data.success) {
                this.reloadPercursos();
                general.success("Percurso '" + percurso.designacao + "' apagado com sucesso.", "Sucesso!");
              } else {
                general.error("Não é possível apagar este percurso.", "Erro!");
              }
            })
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Está prestes a apagar o percurso '{percurso.designacao}'. Todos os cursos associados também serão removidos. Esta ação é irreversível.
        </SweetAlert>
      )
    });
  }

  async novoPercurso() {
    const {classes} = this.props;

    let tipos_curso = await connection.get("percurso/listagem_tipos");

    let percurso = {
      diretor: null,
      tipo: tipos_curso.length === 1 ? tipos_curso[0].codigo : null,
      acontecimento_teste: false
    };

    let Content = () => {
      const [tipo_percurso_state, setTipoPercurso] = useState(percurso.tipo);
      const [percursoTeste, setPercursoTeste] = useState(!!percurso.acontecimento_teste);

      return <form autoComplete="off" className={classes.percursoForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="tipo_percurso" className={classes.selectLabel}>
            Tipo de Percurso
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={tipo_percurso_state}
            onChange={(event) => {
              percurso.tipo = event.target.value;
              setTipoPercurso(event.target.value);
            }}
            inputProps={{
              name: "tipo_percurso",
              id: "tipo_percurso"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o tipo de percurso</MenuItem>
            {tipos_curso.map((tipo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={tipo.codigo}>{tipo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <UserSearch
          labelText="NIN do Diretor"
          id="novoPercurso-diretor"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            name: "diretor",
            min: "0"
          }}
          onFoundUser={(user) => {
            percurso.diretor = user.NIN
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modo_teste" className={classes.selectLabel}>
            Percurso de Teste
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={percursoTeste}
            onChange={(event) => {
              percurso.acontecimento_teste = event.target.value;
              setPercursoTeste(event.target.value);
            }}
            inputProps={{
              name: "modo_teste",
              id: "modo_teste"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione se é um percurso em modo de teste</MenuItem>
            <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={false}>Não</MenuItem>
            <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={true}>Sim. Apenas para teste. Não será visível pelos outros utilizadores.</MenuItem>
          </Select>
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        style={{width: 520}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Percurso</span>
        </div>)}
        onConfirm={async () => {
          let result = await connection.post("percurso/novo", percurso);
          window.App.hist.push("/percurso/" + result.id);
          general.success("Novo percurso criado com sucesso", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText="Criar"
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    })
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  render() {
    const {classes} = this.props;
    let data = general.filterTable(this.state.percursos, this.state.searchTable);
    return (<div className={classes.cursosContainer}>
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Percursos</h4>
                <CustomInput
                  id="tableSearch"
                  formControlProps={{
                    className: classes.searchInput
                  }}
                  inputProps={{
                    type: "text",
                    name: "tableSearch",
                    placeholder: "Pesquisar",
                    onChange: (e) => {
                      this.setState({searchTable: e.target.value})
                    }
                  }}
                />
                {general.userHasPermission("percurso.criar") && <Button className={classes.addCourseButton + " " + classes.button + " " + classes.primary} onClick={this.novoPercurso}>
                  <Add/> Novo Percurso
                </Button>}
              </div>
            </CardHeader>
            <ReactTable
              placeholder={general.userHasPermission("percurso.criar") ? "Ainda não existe nenhum percurso, clique em 'Novo Percurso' para começar" : "Não existem percursos para apresentar"}
              data={data}
              minRows={1}
              columns={[
                {
                  Header: "Designação",
                  accessor: "designacao",
                },
                {
                  Header: "Tipo",
                  accessor: "tipo"
                },
                {
                  Header: "Diretor",
                  accessor: "diretor",
                  Cell: general.Renderers.userRenderer,
                  minWidth: 80
                },
                {
                  Header: "",
                  accessor: "actions",
                  width: 115,
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationBottom={true}
              className="-striped -highlight"
            />
          </Card>
        </GridItem>
      </GridContainer>
    </div>);
  }
}

export default withStyles(percursosStyle)(Percursos);
